(function ($) {
  $(document).ready(function () {
    let windowWidth = $(window).width();
    let maxCol = 4;
	let currentMaxCol = 0;
    let currentCol = 1;

    function checkWhenReminderGrid(maxCol) {

		if(currentMaxCol !== maxCol) {
			currentCol = 1;
			checkShowColumn();
			let gridCards = $('.stories-grid__init .stories-grid__item');
			addCardToColumn(gridCards);

			currentMaxCol = maxCol;
		}
	}

    function checkShowColumn() {
		$('.stories-grid__col').empty();
		$('.stories-grid__col').each(function(index,value) {
			if(index+1 <= maxCol) {
				$(value).removeClass('m-hide');
			} else {
				$(value).addClass('m-hide');
			}
		});
	}

    function checkMaxCol(windowWidth) {
		if(windowWidth < 990) {
			maxCol = 2;
		} else if(windowWidth >= 990 &&  windowWidth < 1200) {
			maxCol = 3;
		} else {
			maxCol = 4;
		}

		checkWhenReminderGrid(maxCol);
	}

    function addCardToColumn(gridCards) {
		$(gridCards).each(function(index, value) {
			let clonedBlock = $(value).clone(true, true);

			if(currentCol === maxCol) {
				$(`.stories-grid__col[data-col="${currentCol}"]`).append(clonedBlock);
				currentCol = 1; 
			} else {
				$(`.stories-grid__col[data-col="${currentCol}"]`).append(clonedBlock);
				currentCol = currentCol + 1; 
			} 
		});
	}

    checkMaxCol(windowWidth);

    $(window).resize(function () {
        let windowWidth = $(window).width();
        checkMaxCol(windowWidth);
    });


    $(document).on('click', '.stories-grid__item__media__video', function() {
        const video = this;
        const $media = $(video).closest('.stories-grid__item__media');

        if (!$media.hasClass('m-play')) {
            $media.addClass('m-play');

            video.muted = true;
            video.setAttribute('controls', 'controls');
            video.get(0).play();
        }
    });
  });
})(jQuery);